import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Box } from '@mui/material'
import PublicHeader from '@/layout-components/PublicHeader'
import { Outlet } from 'react-router'
import {
  publicWrapperSx,
  publicContentSx,
  publicContentInnerSx,
  publicContentInnerWrapperSx,
  publicProformaContentSx,
  publicFullBleedContentInnerSx,
  publicFullBleedContentInnerWrapperSx,
  isPublicProformaHref,
} from '../chromeSx'

/** Public marketplace / Agency marketing shell — not the logged-in AppBar + Drawer. */
const PublicSidebar = (props) => {
  const urlParams = new URLSearchParams(window.location.search)
  const subdomain = urlParams.get('subdomain') || null
  const subdomainParam = subdomain ? '?subdomain=' + subdomain : ''
  const isFullBleedProforma = isPublicProformaHref(window.location.href)

  return (
    <Box sx={publicWrapperSx}>
      <PublicHeader
        subdomainParam={subdomainParam}
        marketplace={props.marketplace}
        orgName={props.orgName}
        header={props.header}
      />
      <Box
        sx={
          isFullBleedProforma ? publicProformaContentSx : publicContentSx
        }
      >
        <Box
          sx={
            isFullBleedProforma
              ? publicFullBleedContentInnerSx
              : publicContentInnerSx
          }
        >
          <Box
            sx={
              isFullBleedProforma
                ? publicFullBleedContentInnerWrapperSx
                : publicContentInnerWrapperSx
            }
          >
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

PublicSidebar.propTypes = {
  children: PropTypes.node,
}

const mapStateToProps = (state) => ({
  sidebarShadow: state.DeprecatedThemeOptions.sidebarShadow,
  sidebarToggle: state.DeprecatedThemeOptions.sidebarToggle,
  sidebarToggleMobile:
    state.DeprecatedThemeOptions.sidebarToggleMobile,
  sidebarFixed: state.DeprecatedThemeOptions.sidebarFixed,
  headerFixed: state.DeprecatedThemeOptions.headerFixed,
  headerSearchHover: state.DeprecatedThemeOptions.headerSearchHover,
  headerDrawerToggle: state.DeprecatedThemeOptions.headerDrawerToggle,
  notificationsDrawerToggle:
    state.DeprecatedThemeOptions.notificationsDrawerToggle,
  footerFixed: state.DeprecatedThemeOptions.footerFixed,
})

export default connect(mapStateToProps)(PublicSidebar)
